/** @jsxImportSource @emotion/react */
import React from 'react'

interface GameStatusIconProps {
  size?: number
  color?: string
  className?: string
}

const GameStatusIcon: React.FC<GameStatusIconProps> = ({
  size = 16,
  color = 'white',
  className,
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    className={className}
  >
    <path
      d='M11.9997 6.66667H10.333C9.96634 6.66667 9.66634 6.96667 9.66634 7.33333V10C9.66634 10.3667 9.96634 10.6667 10.333 10.6667H11.9997C12.3663 10.6667 12.6663 10.3667 12.6663 10V7.33333C12.6663 6.96667 12.3663 6.66667 11.9997 6.66667ZM11.6663 9.66667H10.6663V7.66667H11.6663V9.66667ZM6.33301 10.6667H3.33301V9C3.33301 8.63333 3.63301 8.33333 3.99967 8.33333H5.33301V7.66667H3.33301V6.66667H5.66634C6.03301 6.66667 6.33301 6.96667 6.33301 7.33333V8.33333C6.33301 8.7 6.03301 9 5.66634 9H4.33301V9.66667H6.33301V10.6667ZM8.49967 8H7.49967V7H8.49967V8ZM8.49967 10.3333H7.49967V9.33333H8.49967V10.3333ZM14.6663 4.66667V12.6667C14.6663 13.4 14.0663 14 13.333 14H2.66634C1.93301 14 1.33301 13.4 1.33301 12.6667V4.66667C1.33301 3.93333 1.93301 3.33333 2.66634 3.33333H4.66634V2H5.99967V3.33333H9.99967V2H11.333V3.33333H13.333C14.0663 3.33333 14.6663 3.93333 14.6663 4.66667ZM13.333 12.6667V4.66667H8.49967V5.66667H7.49967V4.66667H2.66634V12.6667H7.49967V11.6667H8.49967V12.6667H13.333Z'
      fill={color}
    />
  </svg>
)

export default GameStatusIcon
